import { Button } from '@/shared/components';
import { useAutomationStatus } from './AutomationLayerContext';

/**
 * Hinweis, wenn die Preisautomatik-Schicht nicht geladen werden konnte: ohne ihn läse sich ein
 * Kalender ohne Ziele und „!“-Marken wie „alles bestätigt“.
 */
export function AutomationProblemHint() {
  const status = useAutomationStatus();
  if (!status) return null;
  return (
    <div
      role="status"
      className="bg-amber-wash text-amber-ink border-hairline flex flex-wrap items-center gap-3 border-b px-[18px] py-2 text-[13px]"
    >
      <span className="min-w-0 flex-1">
        {status.stale
          ? 'Preisautomatik: Nachladen fehlgeschlagen – Ziele und Marken zeigen den zuletzt geladenen Stand.'
          : `${status.message} Ziele, Modus und Übertragungsmarken der Automatik fehlen deshalb.`}
      </span>
      <Button variant="ghost" className="min-h-11" onClick={status.retry} loading={status.retrying}>
        Erneut laden
      </Button>
    </div>
  );
}
